<script setup lang="ts">
import { defineProps } from "vue";

type Props = {
  buttonText: string;
};

defineProps<Props>();
</script>

<template>
  <button
    class="bg-[#DDDDFB] border border-[#DDDDFB] w-full h-[44px] rounded-primary-radius px-3 flex items-center justify-center text-primary-text-color text-base leading-5 tracking-[0.01rem] font-semibold"
  >
    {{ buttonText }}
  </button>
</template>
